import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';
import router from '@/plugins/vue-router';

export class MailingsUpdate extends BaseNotification {
  constructor(data) {
    super(data);
  }

  getText() {
    const props = this.getI18nProps();
    const route = { name: 'mailer.mailing.index' };
    const link_href = router.resolve(route).href;
    const link_tag = `<a style="color: #fff;" href="${link_href}">${props.text_link}</a>`;

    return `${props.text_body} ${link_tag}`;
  }

  getTheme() {
    const { status, custom_data } = this.params;

    if (status === 'pending' || custom_data?.message === 'moderation_success') {
      return BaseNotification.THEME_SUCCESS;
    } else if (status === 'rejected' || custom_data?.message === 'moderate_too_late' || status === 'failed' ) {
      return BaseNotification.THEME_ERROR;
    }
  }

  getI18nProps() {
    const { name, status, custom_data } = this.params;
    const route = { name: 'mailer.mailing.index' };

    let text_body = '';

    if (status === 'pending') {
      text_body = i18n.t(`notify.notification.mailings_update.pending`, {
        name: `<strong>${name}</strong>`
      });
    }
    if (status === 'rejected') {
      text_body = i18n.t(`notify.notification.mailings_update.rejected`, {
        name: `<strong>${name}</strong>`
      });
    }

    if (status === 'failed') {
      text_body = i18n.t(`notify.notification.mailings_update.failed`, {
        name: `<strong>${name}</strong>`
      });
    }

    if (custom_data?.message === 'moderation_success' && !!custom_data?.start_at) {
      text_body = i18n.t(`notify.notification.mailings_update.moderation_success`, {
        name: `<strong>${name}</strong>`,
        start_at: custom_data?.start_at
      });
    }

    if (custom_data?.message === 'moderate_too_late') {
      text_body = i18n.t(`notify.notification.mailings_update.moderate_too_late`, {
        name: `<strong>${name}</strong>`
      });
    }

    return {
      text_body,
      path: route,
      text_link: i18n.t(`notify.notification.senders_update.text_link`)
    };
  }
}
